'use client';

export function ProcessingIndicator() {
  return (
    <div className="flex justify-start">
      <div className="bg-light-purple/50 px-4 py-3 rounded-2xl rounded-bl-md">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 relative">
            <div className="absolute inset-0 rounded-full border-2 border-off-black/20 border-t-off-black/60 animate-spin" />
          </div>
          <span className="text-sm text-off-black/60">Even nadenken...</span>
        </div>
      </div>
    </div>
  );
}
